/** Service Desk console: listahan at detalye ng mga Organisasyon (C03/C04, SD-S1-45). */
export const serviceOrg = {
  subtitle: "Ang mga kumpanyang kliyente na sinusuportahan mo: ang mga tao nila, mga ticket at patakaran sa pag-order.",
  actions: {
    import: "I-import",
    create: "Bagong organisasyon",
    edit: "I-edit",
    archive: "I-archive",
    restore: "Ibalik",
    contacts: "Mga Contact",
  },
  stats: {
    label: "Buod",
    organisations: "Mga Organisasyon",
    organisationsHint: "hindi naka-archive",
    contacts: "Mga Contact",
    contactsHint: "sa lahat ng organisasyon",
    pending: "Mga naghihintay sumali",
    pendingHint: "naghihintay ng pag-apruba",
  },
  filters: {
    search: "Hanapin ang pangalan, code, domain…",
    searchLabel: "Maghanap ng organisasyon",
    kind: "Uri",
    allKinds: "Lahat ng uri",
    status: "Katayuan",
    allStatuses: "Aktibo at naka-hold",
    clear: "I-clear ang mga filter",
  },
  kind: { customer: "Customer", prospect: "Prospect", partner: "Partner", internal: "Panloob" },
  status: { active: "Aktibo", on_hold: "Naka-hold", archived: "Naka-archive" },
  table: {
    label: "Mga Organisasyon",
    organisation: "Organisasyon",
    tier: "Tier",
    kind: "Uri",
    contacts: "Mga Contact",
    status: "Katayuan",
    manager: "Account manager",
    noTier: "Walang tier",
    noManager: "Walang nakatalaga",
    pending_one: "{{count}} naghihintay",
    pending_other: "{{count}} naghihintay",
    pendingLabel_one: "{{count}} naghihintay sumali, suriin sa Mga Contact",
    pendingLabel_other: "{{count}} naghihintay sumali, suriin sa Mga Contact",
    showing: "Ipinapakita ang {{shown}} sa {{total}} organisasyon",
    loadMore: "Magpakita pa",
    contactsCount_one: "{{count}} contact",
    contactsCount_other: "{{count}} contact",
  },
  empty: {
    title: "Wala pang organisasyon",
    body: "Idagdag ang mga kumpanyang kliyente na sinusuportahan mo, o i-import ang mga ito mula sa spreadsheet.",
    filteredTitle: "Walang tugmang organisasyon",
    filteredBody: "Subukan ang ibang hanap o i-clear ang mga filter.",
  },
  error: { title: "Hindi namin ma-load ang mga organisasyon", body: "May problema sa aming panig. Subukan ulit." },
  form: {
    createTitle: "Bagong organisasyon",
    createDescription: "Isang kumpanyang kliyente. Idagdag ang mga tao at patakaran sa pag-order mamaya, o i-import ang mga ito.",
    editTitle: "I-edit ang organisasyon",
    editDescription: "Nalalapat ang mga pagbabago sa lahat ng contact at ticket ng organisasyong ito.",
    name: "Pangalan ng organisasyon",
    namePlaceholder: "hal. Cebu Marine Research Institute",
    code: "Code",
    codeHint: "Opsyonal at natatangi. Mga letra, numero, tuldok, gitling o underscore, hanggang {{max}} karakter. Ginagamit sa mga listahan at link.",
    industry: "Industriya",
    industryPlaceholder: "hal. Klinikal na laboratoryo",
    tier: "Tier",
    tierPlaceholder: "hal. Gold",
    kind: "Uri",
    manager: "Account manager",
    noManager: "Walang nakatalaga",
    domain: "E-mail domain para sa auto-join",
    domainHint: "Opsyonal. Maghihintay ng pag-apruba mo ang mga bagong sasali mula sa domain na ito.",
    domainPlaceholder: "example.com.ph",
    notes: "Mga tala",
    cancel: "Kanselahin",
    create: "Gumawa ng organisasyon",
    save: "I-save ang mga pagbabago",
    created: "Nagawa na ang {{name}}",
    updated: "Na-update ang organisasyon",
  },
  validation: {
    name: "Ilagay ang pangalan ng organisasyon ({{min}} hanggang {{max}} karakter).",
    code: "Gumamit ng mga letra at numero, hanggang {{max}} karakter (puwede ang tuldok, gitling at underscore sa loob).",
    domain: "Maglagay ng domain tulad ng example.com.ph (walang @, espasyo o path).",
    tier: "Hanggang {{max}} karakter lang ang tier.",
  },
  errors: {
    nameTaken: "May organisasyon nang may ganitong pangalan.",
    codeTaken: "Ginagamit na ng ibang organisasyon ang code na ito.",
    publicDomain: "Pampublikong e-mail provider ang {{domain}}. Mag-map ng domain na pag-aari ng kliyente mo.",
    domainInUse: "Pag-aari na ng ibang organisasyon ang {{domain}}.",
    domainsTooMany: "Hanggang {{max}} e-mail domain lang ang puwedeng i-map ng isang organisasyon.",
    domainsRepeated: "Nasa listahan na ang domain na ito.",
  },
  detail: {
    sections: "Mga seksyon ng organisasyon",
    notFoundTitle: "Hindi nakita ang organisasyon",
    notFoundBody: "Maaaring natanggal na ito, o mali ang link.",
    back: "Bumalik sa mga organisasyon",
    subline: "Account manager: {{manager}}",
    pendingJoiners_one: "{{count}} naghihintay sumali",
    pendingJoiners_other: "{{count}} naghihintay sumali",
    archivedBanner: "Naka-archive ang organisasyong ito. Ibalik ito para makatanggap ng bagong contact at ticket.",
    archiveTitle: "I-archive ang {{name}}?",
    archiveBody: "Aalis ito sa mga listahan at sa mga contact picker. Mananatili ang kasaysayan ng mga contact at ticket, at puwede mo itong ibalik anumang oras.",
    archiveConfirm: "I-archive ang organisasyon",
    archived: "Na-archive ang {{name}}",
    restored: "Naibalik ang {{name}}",
    loading: "Nilo-load ang organisasyon",
  },
  tabs: { overview: "Pangkalahatang-tanaw", contacts: "Mga Contact", tickets: "Mga Ticket", activity: "Aktibidad", assets: "Mga Asset", contracts: "Mga Kontrata", projects: "Mga Proyekto", visits: "Mga Visit", orders: "Mga Order" },
  overview: {
    openTickets: "Mga bukas na ticket",
    openTicketsHint: "nasa pila ngayon",
    contacts: "Mga Contact",
    contactsHint: "mga tao sa organisasyong ito",
    pending: "Mga naghihintay sumali",
    pendingHint: "naghihintay ng pag-apruba",
    ordering: "Pag-order",
    orderingOn: "Naka-on",
    orderingOff: "Naka-off",
    detailsTitle: "Mga detalye",
    notes: "Mga tala",
    noNotes: "Wala pang tala.",
    created: "Idinagdag",
    recentTitle: "Mga bukas na ticket",
    noOpenTickets: "Walang bukas na ticket.",
    noAccessTickets: "Kailangan mo ng access sa ticket para makita ang mga ticket ng organisasyong ito.",
  },
  fields: { kind: "Uri", tier: "Tier", industry: "Industriya", manager: "Account manager", status: "Katayuan", code: "Code" },
  domains: {
    title: "Mga domain at auto-join",
    intro:
      "Puwedeng sumali sa organisasyong ito ang mga nagve-verify ng e-mail sa isa sa mga domain na ito. Hindi kailanman tinatanggap ang mga pampublikong e-mail provider tulad ng Gmail.",
    empty: "Walang domain. Kailangan ng imbitasyon ng mga sasali.",
    list: "Mga naka-map na e-mail domain",
    add: "Bagong domain",
    addAction: "Magdagdag ng domain",
    added: "Naidagdag ang @{{domain}}",
    remove: "Alisin ang @{{domain}}",
    removeTitle: "Alisin ang @{{domain}}?",
    removeBody: "Kakailanganin ng imbitasyon ng mga taong may ganitong domain para makasali. Hindi natatanggal ang mga kasalukuyang contact.",
    removeConfirm: "Alisin ang domain",
    removed: "Naalis ang @{{domain}}",
    autoJoin: "Kapag may sumali gamit ang domain",
    autoJoinSaved: "Na-update ang auto-join",
    mode: {
      off: "Huwag i-auto-join (imbitasyon lang)",
      as_user: "Papasukin agad bilang miyembro",
      pending_approval: "Hintayin ang pag-apruba ko",
    },
    readOnly: "Ang mga may pahintulot lang mag-manage ng organisasyon ang puwedeng magbago ng mga domain.",
    pendingBanner_one: "{{count}} sasali ang naghihintay ng pag-apruba.",
    pendingBanner_other: "{{count}} sasali ang naghihintay ng pag-apruba.",
    review: "Suriin",
  },
  ordering: {
    title: "Mga setting ng pag-order",
    note: "Bubukas ang pag-order sa susunod na release. Ito ang mga halagang nakatala; hindi mo pa mababago ang mga ito rito.",
    enabled: "Pag-order",
    enabledOn: "Naka-on",
    enabledOff: "Naka-off",
    poRequired: "Numero ng purchase order",
    poYes: "Kailangan",
    poNo: "Hindi kailangan",
    threshold: "Kailangan ng pag-apruba kapag lampas sa",
    noThreshold: "Walang limitasyon",
    priceList: "Listahan ng presyo",
    paymentTerms: "Termino ng pagbabayad",
    notSet: "Hindi pa naka-set",
    offBanner: "Naka-off ang pag-order para sa organisasyong ito.",
  },
  contactsTab: {
    label: "Mga contact ng organisasyong ito",
    name: "Pangalan",
    jobTitle: "Posisyon",
    role: "Tungkulin sa org",
    verified: "Na-verify",
    ordering: "Pag-order",
    open: "Buksan",
    openLabel: "Buksan si {{name}}",
    emptyTitle: "Wala pang contact",
    emptyBody: "Sumasali ang mga tao gamit ang e-mail domain, imbitasyon o spreadsheet import.",
    importContacts: "I-import ang mga contact",
    pendingBanner: "Sumali si {{name}} gamit ang domain na {{domain}} at naghihintay ng pag-apruba.",
    review: "Suriin",
    showing: "Ipinapakita ang {{shown}} sa {{total}} contact",
    loadMore: "Magpakita pa",
    error: "Hindi namin ma-load ang mga contact ng organisasyong ito",
  },
  ticketsTab: {
    label: "Mga ticket ng organisasyong ito",
    filter: "Filter ng ticket",
    open: "Bukas",
    all: "Lahat",
    ticket: "Ticket",
    title: "Pamagat",
    requester: "Humihiling",
    status: "Katayuan",
    priority: "Priyoridad",
    updated: "Na-update",
    emptyTitle: "Walang ticket",
    emptyBody: "Walang ticket ang organisasyong ito sa view na ito.",
    error: "Hindi namin ma-load ang mga ticket ng organisasyong ito",
    noAccessTitle: "Kailangan ng access sa ticket",
    noAccessBody: "Hingin sa admin ang pahintulot sa Mga Ticket para makita ang mga ticket ng organisasyong ito.",
    showing: "Ipinapakita ang {{shown}} sa {{total}} ticket",
    loadMore: "Magpakita pa",
  },
  activity: {
    title: "Aktibidad",
    subtitle: "Mga ticket, tao at pangyayari sa account, pinakabago muna",
    empty: "Wala pang aktibidad.",
    created: "Naidagdag ang organisasyon",
    contactAdded: "Naidagdag si {{name}} bilang contact",
    contactPending: "Humiling sumali si {{name}} (domain na {{domain}})",
    contactPendingNoDomain: "Humiling sumali si {{name}}",
    ticket: "{{number}} · {{title}}",
    error: "Hindi namin ma-load ang aktibidad ng organisasyong ito",
    list: "Aktibidad ng organisasyong ito",
  },
} as const;
